  <h2 *ngIf="!isOnline" class="mx-8 my-8">You are offline. Please check your connection to continue using the app.</h2>
  <h2 *ngIf="isOnline" class="mx-8 my-8">You are back online! You can now navigate the app as usual. </h2>
